import { Flex, Paper, ScrollArea, Text } from '@mantine/core';
import { IconMoodAngry, IconMoodTongueWink } from '@tabler/icons-react';
import classes from './ReviewAnswersList.module.scss';

type ReviewAnswerItem = {
  id: number;
  question: {
    name: string;
  };
  answer: boolean;
};

type ReviewAnswersListProps = {
  answers: ReviewAnswerItem[];
};

export const ReviewAnswersList = ({ answers }: ReviewAnswersListProps) => {
  if (!answers.length) {
    return null;
  }

  return (
    <Flex direction='column' gap={16} className={classes.wrapper}>
      <ScrollArea.Autosize
        mah={276}
        offsetScrollbars={answers.length > 3}
        scrollbarSize={4}
      >
        <Flex direction='column' gap={4}>
          {answers.map(item => (
            <Paper key={item.id} p={16} radius={16} bg='otherWhite.0'>
              <Flex justify='space-between' align='center' gap={16}>
                <Text size='sm' c='tertiary.7' fw={600}>
                  {item.question.name}
                </Text>
                <Flex
                  data-variant={item.answer ? 'green' : 'red'}
                  className={classes.answerIcon}
                >
                  {item.answer ? (
                    <IconMoodTongueWink
                      size={24}
                      color='var(--mantine-color-green-7)'
                    />
                  ) : (
                    <IconMoodAngry
                      size={24}
                      color='var(--mantine-color-red-7)'
                    />
                  )}
                </Flex>
              </Flex>
            </Paper>
          ))}
        </Flex>
      </ScrollArea.Autosize>

      <Flex gap={16} wrap='wrap'>
        <Flex align='center' gap={8}>
          <span className={classes.legendDot} data-variant='yes' />
          <Text size='sm' c='tertiary.7'>
            — Да
          </Text>
        </Flex>
        <Flex align='center' gap={8}>
          <span className={classes.legendDot} data-variant='no' />
          <Text size='sm' c='tertiary.7'>
            — Нет
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
